var map = {
	"./329x225-zaslepka-rozwijana.jpg": "./assets/images/329x225-zaslepka-rozwijana.jpg",
	"./BIP.png": "./assets/images/BIP.png",
	"./Bilety.svg": "./assets/images/Bilety.svg",
	"./Darkness_mini__1_18_19.jpg": "./assets/images/Darkness_mini__1_18_19.jpg",
	"./Dziadek_mini_1_18_19_.jpg": "./assets/images/Dziadek_mini_1_18_19_.jpg",
	"./Dziecko.svg": "./assets/images/Dziecko.svg",
	"./FB.png": "./assets/images/FB.png",
	"./Flaga.svg": "./assets/images/Flaga.svg",
	"./Header_18_19_329x225.jpg": "./assets/images/Header_18_19_329x225.jpg",
	"./Informacja.svg": "./assets/images/Informacja.svg",
	"./Kosz.svg": "./assets/images/Kosz.svg",
	"./Koszyk.svg": "./assets/images/Koszyk.svg",
	"./Krol_Roger_miniaturka.jpg": "./assets/images/Krol_Roger_miniaturka.jpg",
	"./Kup_bilet_mini.jpg": "./assets/images/Kup_bilet_mini.jpg",
	"./Logo_Instagrama_Fiolet_.png": "./assets/images/Logo_Instagrama_Fiolet_.png",
	"./Megafon.svg": "./assets/images/Megafon.svg",
	"./Niepelnosprawny.svg": "./assets/images/Niepelnosprawny.svg",
	"./Oko.svg": "./assets/images/Oko.svg",
	"./PADEREWSKI045_kalendarium_370px.jpg": "./assets/images/PADEREWSKI045_kalendarium_370px.jpg",
	"./UW_dla_dzieci_mini_.jpg": "./assets/images/UW_dla_dzieci_mini_.jpg",
	"./UW_dorosli_mini_.jpg": "./assets/images/UW_dorosli_mini_.jpg",
	"./Vod_teatr_wielki_pl.jpg": "./assets/images/Vod_teatr_wielki_pl.jpg",
	"./Warszawa-Frankfurt_kwadrat.jpg": "./assets/images/Warszawa-Frankfurt_kwadrat.jpg",
	"./YT.png": "./assets/images/YT.png",
	"./Zegar.svg": "./assets/images/Zegar.svg",
	"./Zegar_Pasek_Gorny.svg": "./assets/images/Zegar_Pasek_Gorny.svg",
	"./abonamenty_header.jpg": "./assets/images/abonamenty_header.jpg",
	"./akt_spektakl-02.jpg": "./assets/images/akt_spektakl-02.jpg",
	"./akt_spektakl-03.jpg": "./assets/images/akt_spektakl-03.jpg",
	"./akt_spektakl.jpg": "./assets/images/akt_spektakl.jpg",
	"./amfiteatr.png": "./assets/images/amfiteatr.png",
	"./arrow-select.png": "./assets/images/arrow-select.png",
	"./arrow.png": "./assets/images/arrow.png",
	"./arrow_white.png": "./assets/images/arrow_white.png",
	"./avi.png": "./assets/images/avi.png",
	"./balkon1.png": "./assets/images/balkon1.png",
	"./balkon2.png": "./assets/images/balkon2.png",
	"./balkon3.png": "./assets/images/balkon3.png",
	"./bestsellers-09.jpg": "./assets/images/bestsellers-09.jpg",
	"./bestsellers-10.jpg": "./assets/images/bestsellers-10.jpg",
	"./bestsellers-11.jpg": "./assets/images/bestsellers-11.jpg",
	"./bestsellers.jpg": "./assets/images/bestsellers.jpg",
	"./bestsellers_00.jpg": "./assets/images/bestsellers_00.jpg",
	"./bg-grey-transparent.png": "./assets/images/bg-grey-transparent.png",
	"./bg-transparent.png": "./assets/images/bg-transparent.png",
	"./bg.jpg": "./assets/images/bg.jpg",
	"./bg_abonaments.jpg": "./assets/images/bg_abonaments.jpg",
	"./bilety__mobile__balkon.jpg": "./assets/images/bilety__mobile__balkon.jpg",
	"./blank.gif": "./assets/images/blank.gif",
	"./blank.png": "./assets/images/blank.png",
	"./bmw_jazz_club_2018_kwadrat.jpg": "./assets/images/bmw_jazz_club_2018_kwadrat.jpg",
	"./butik-slider.png": "./assets/images/butik-slider.png",
	"./csm_1._Dziadek_IMG_5690_new_284e371588.jpg": "./assets/images/csm_1._Dziadek_IMG_5690_new_284e371588.jpg",
	"./csm_Krol_Roger_457x637_polecane_06a5300001.jpg": "./assets/images/csm_Krol_Roger_457x637_polecane_06a5300001.jpg",
	"./csm_eros_i_psyche_BIEL8077_slider_mobile_d6eb66c14f.png": "./assets/images/csm_eros_i_psyche_BIEL8077_slider_mobile_d6eb66c14f.png",
	"./csm_kalendarium-bg_02_bf6264b6d5.jpg": "./assets/images/csm_kalendarium-bg_02_bf6264b6d5.jpg",
	"./csm_moniuszko-kopia_slider_mobile_01_6855f59ec1.png": "./assets/images/csm_moniuszko-kopia_slider_mobile_01_6855f59ec1.png",
	"./csm_paderewski_457x637_10f0f2bfaa.jpg": "./assets/images/csm_paderewski_457x637_10f0f2bfaa.jpg",
	"./csm_rigoletto_slider_mobile_f2424c9bee.png": "./assets/images/csm_rigoletto_slider_mobile_f2424c9bee.png",
	"./cud_albo_krakowiaki_i_gorale.png": "./assets/images/cud_albo_krakowiaki_i_gorale.png",
	"./custom-select.png": "./assets/images/custom-select.png",
	"./cyrulik_kalendarium.jpg": "./assets/images/cyrulik_kalendarium.jpg",
	"./czarodziejski_flet.png": "./assets/images/czarodziejski_flet.png",
	"./czarodziejski_mini_18_19_.jpg": "./assets/images/czarodziejski_mini_18_19_.jpg",
	"./default-contrast.gif": "./assets/images/default-contrast.gif",
	"./desktop.svg": "./assets/images/desktop.svg",
	"./doc.png": "./assets/images/doc.png",
	"./docx.png": "./assets/images/docx.png",
	"./drag-left.png": "./assets/images/drag-left.png",
	"./drag-right.png": "./assets/images/drag-right.png",
	"./dziadek_do_orzechow_i_krol_myszy.png": "./assets/images/dziadek_do_orzechow_i_krol_myszy.png",
	"./edycja_limitowana.jpg": "./assets/images/edycja_limitowana.jpg",
	"./email.jpg": "./assets/images/email.jpg",
	"./email.svg": "./assets/images/email.svg",
	"./eye.jpg": "./assets/images/eye.jpg",
	"./flaga.jpg": "./assets/images/flaga.jpg",
	"./font-default-win.png": "./assets/images/font-default-win.png",
	"./font-minus-win.png": "./assets/images/font-minus-win.png",
	"./font-plus-win.png": "./assets/images/font-plus-win.png",
	"./fragment.jpg": "./assets/images/fragment.jpg",
	"./gala_sylwestrowa_mini_2_.jpg": "./assets/images/gala_sylwestrowa_mini_2_.jpg",
	"./gif.png": "./assets/images/gif.png",
	"./hamburger.png": "./assets/images/hamburger.png",
	"./hr-header-article.png": "./assets/images/hr-header-article.png",
	"./icon-close.jpg": "./assets/images/icon-close.jpg",
	"./icon-info.jpg": "./assets/images/icon-info.jpg",
	"./icon-info.svg": "./assets/images/icon-info.svg",
	"./icon-tickets.png": "./assets/images/icon-tickets.png",
	"./icon__tour-02.png": "./assets/images/icon__tour-02.png",
	"./icon__tour-03.png": "./assets/images/icon__tour-03.png",
	"./icon__tour-04.png": "./assets/images/icon__tour-04.png",
	"./icon__tour.png": "./assets/images/icon__tour.png",
	"./icon_plus.jpg": "./assets/images/icon_plus.jpg",
	"./ikon-kosz.jpg": "./assets/images/ikon-kosz.jpg",
	"./ikona-kalendarz.jpg": "./assets/images/ikona-kalendarz.jpg",
	"./ikona-samolot.jpg": "./assets/images/ikona-samolot.jpg",
	"./ikona-zakupy.jpg": "./assets/images/ikona-zakupy.jpg",
	"./ikona_kciuk.jpg": "./assets/images/ikona_kciuk.jpg",
	"./ikona_platnosci-02.jpg": "./assets/images/ikona_platnosci-02.jpg",
	"./ikona_platnosci-03.jpg": "./assets/images/ikona_platnosci-03.jpg",
	"./ikona_platnosci.jpg": "./assets/images/ikona_platnosci.jpg",
	"./ikony/black/icon-add.png": "./assets/images/ikony/black/icon-add.png",
	"./ikony/black/icon-address.png": "./assets/images/ikony/black/icon-address.png",
	"./ikony/black/icon-arrow-left.png": "./assets/images/ikony/black/icon-arrow-left.png",
	"./ikony/black/icon-arrow-right.png": "./assets/images/ikony/black/icon-arrow-right.png",
	"./ikony/black/icon-calendar.png": "./assets/images/ikony/black/icon-calendar.png",
	"./ikony/black/icon-cart-black.png": "./assets/images/ikony/black/icon-cart-black.png",
	"./ikony/black/icon-cart.png": "./assets/images/ikony/black/icon-cart.png",
	"./ikony/black/icon-clock.png": "./assets/images/ikony/black/icon-clock.png",
	"./ikony/black/icon-codes.png": "./assets/images/ikony/black/icon-codes.png",
	"./ikony/black/icon-delivery.png": "./assets/images/ikony/black/icon-delivery.png",
	"./ikony/black/icon-disability.png": "./assets/images/ikony/black/icon-disability.png",
	"./ikony/black/icon-drag-left.png": "./assets/images/ikony/black/icon-drag-left.png",
	"./ikony/black/icon-drag-right.png": "./assets/images/ikony/black/icon-drag-right.png",
	"./ikony/black/icon-email.png": "./assets/images/ikony/black/icon-email.png",
	"./ikony/black/icon-foreign-languages.png": "./assets/images/ikony/black/icon-foreign-languages.png",
	"./ikony/black/icon-grid.svg": "./assets/images/ikony/black/icon-grid.svg",
	"./ikony/black/icon-history.png": "./assets/images/ikony/black/icon-history.png",
	"./ikony/black/icon-home.png": "./assets/images/ikony/black/icon-home.png",
	"./ikony/black/icon-info.png": "./assets/images/ikony/black/icon-info.png",
	"./ikony/black/icon-invoice.png": "./assets/images/ikony/black/icon-invoice.png",
	"./ikony/black/icon-listing.svg": "./assets/images/ikony/black/icon-listing.svg",
	"./ikony/black/icon-logo.png": "./assets/images/ikony/black/icon-logo.png",
	"./ikony/black/icon-loupe.png": "./assets/images/ikony/black/icon-loupe.png",
	"./ikony/black/icon-password.png": "./assets/images/ikony/black/icon-password.png",
	"./ikony/black/icon-plane.png": "./assets/images/ikony/black/icon-plane.png",
	"./ikony/black/icon-remove.png": "./assets/images/ikony/black/icon-remove.png",
	"./ikony/black/icon-settings-black.png": "./assets/images/ikony/black/icon-settings-black.png",
	"./ikony/black/icon-settings.png": "./assets/images/ikony/black/icon-settings.png",
	"./ikony/black/icon-shopping.png": "./assets/images/ikony/black/icon-shopping.png",
	"./ikony/black/icon-special-needs.png": "./assets/images/ikony/black/icon-special-needs.png",
	"./ikony/black/icon-thumb.png": "./assets/images/ikony/black/icon-thumb.png",
	"./ikony/black/icon-tickets.png": "./assets/images/ikony/black/icon-tickets.png",
	"./ikony/black/icon-time-of-sightseeing.png": "./assets/images/ikony/black/icon-time-of-sightseeing.png",
	"./ikony/black/icon-user-2.png": "./assets/images/ikony/black/icon-user-2.png",
	"./ikony/black/icon-user.png": "./assets/images/ikony/black/icon-user.png",
	"./ikony/black/icon__tour-02.png": "./assets/images/ikony/black/icon__tour-02.png",
	"./ikony/black/icon__tour-03.png": "./assets/images/ikony/black/icon__tour-03.png",
	"./ikony/black/icon__tour-04.png": "./assets/images/ikony/black/icon__tour-04.png",
	"./ikony/black/icon__tour.png": "./assets/images/ikony/black/icon__tour.png",
	"./ikony/black/icon_plus.png": "./assets/images/ikony/black/icon_plus.png",
	"./ikony/social-menu/BIP-2.png": "./assets/images/ikony/social-menu/BIP-2.png",
	"./ikony/social-menu/facebook-black.svg": "./assets/images/ikony/social-menu/facebook-black.svg",
	"./ikony/social-menu/facebook-white.svg": "./assets/images/ikony/social-menu/facebook-white.svg",
	"./ikony/social-menu/facebook-yellow.svg": "./assets/images/ikony/social-menu/facebook-yellow.svg",
	"./ikony/social-menu/instagram-black.svg": "./assets/images/ikony/social-menu/instagram-black.svg",
	"./ikony/social-menu/instagram-white.svg": "./assets/images/ikony/social-menu/instagram-white.svg",
	"./ikony/social-menu/instagram-yellow.svg": "./assets/images/ikony/social-menu/instagram-yellow.svg",
	"./ikony/social-menu/youtube-black.svg": "./assets/images/ikony/social-menu/youtube-black.svg",
	"./ikony/social-menu/youtube-white.svg": "./assets/images/ikony/social-menu/youtube-white.svg",
	"./ikony/social-menu/youtube-yellow.svg": "./assets/images/ikony/social-menu/youtube-yellow.svg",
	"./ikony/white/icon-add.png": "./assets/images/ikony/white/icon-add.png",
	"./ikony/white/icon-address.png": "./assets/images/ikony/white/icon-address.png",
	"./ikony/white/icon-arrow-left.png": "./assets/images/ikony/white/icon-arrow-left.png",
	"./ikony/white/icon-arrow-right.png": "./assets/images/ikony/white/icon-arrow-right.png",
	"./ikony/white/icon-calendar.png": "./assets/images/ikony/white/icon-calendar.png",
	"./ikony/white/icon-cart.png": "./assets/images/ikony/white/icon-cart.png",
	"./ikony/white/icon-clock.png": "./assets/images/ikony/white/icon-clock.png",
	"./ikony/white/icon-codes.png": "./assets/images/ikony/white/icon-codes.png",
	"./ikony/white/icon-delivery.png": "./assets/images/ikony/white/icon-delivery.png",
	"./ikony/white/icon-disability.png": "./assets/images/ikony/white/icon-disability.png",
	"./ikony/white/icon-drag-left.png": "./assets/images/ikony/white/icon-drag-left.png",
	"./ikony/white/icon-drag-right.png": "./assets/images/ikony/white/icon-drag-right.png",
	"./ikony/white/icon-email.png": "./assets/images/ikony/white/icon-email.png",
	"./ikony/white/icon-foreign-languages.png": "./assets/images/ikony/white/icon-foreign-languages.png",
	"./ikony/white/icon-grid.svg": "./assets/images/ikony/white/icon-grid.svg",
	"./ikony/white/icon-history.png": "./assets/images/ikony/white/icon-history.png",
	"./ikony/white/icon-home.png": "./assets/images/ikony/white/icon-home.png",
	"./ikony/white/icon-info.png": "./assets/images/ikony/white/icon-info.png",
	"./ikony/white/icon-invoice.png": "./assets/images/ikony/white/icon-invoice.png",
	"./ikony/white/icon-listing.svg": "./assets/images/ikony/white/icon-listing.svg",
	"./ikony/white/icon-logo.png": "./assets/images/ikony/white/icon-logo.png",
	"./ikony/white/icon-loupe.png": "./assets/images/ikony/white/icon-loupe.png",
	"./ikony/white/icon-password.png": "./assets/images/ikony/white/icon-password.png",
	"./ikony/white/icon-plane.png": "./assets/images/ikony/white/icon-plane.png",
	"./ikony/white/icon-remove.png": "./assets/images/ikony/white/icon-remove.png",
	"./ikony/white/icon-settings-white.png": "./assets/images/ikony/white/icon-settings-white.png",
	"./ikony/white/icon-settings.png": "./assets/images/ikony/white/icon-settings.png",
	"./ikony/white/icon-shopping.png": "./assets/images/ikony/white/icon-shopping.png",
	"./ikony/white/icon-special-needs.png": "./assets/images/ikony/white/icon-special-needs.png",
	"./ikony/white/icon-thumb.png": "./assets/images/ikony/white/icon-thumb.png",
	"./ikony/white/icon-tickets.png": "./assets/images/ikony/white/icon-tickets.png",
	"./ikony/white/icon-time-of-sightseeing.png": "./assets/images/ikony/white/icon-time-of-sightseeing.png",
	"./ikony/white/icon-user-2.png": "./assets/images/ikony/white/icon-user-2.png",
	"./ikony/white/icon-user.png": "./assets/images/ikony/white/icon-user.png",
	"./ikony/white/icon__tour-02.png": "./assets/images/ikony/white/icon__tour-02.png",
	"./ikony/white/icon__tour-03.png": "./assets/images/ikony/white/icon__tour-03.png",
	"./ikony/white/icon__tour-04.png": "./assets/images/ikony/white/icon__tour-04.png",
	"./ikony/white/icon__tour.png": "./assets/images/ikony/white/icon__tour.png",
	"./ikony/white/icon_plus.png": "./assets/images/ikony/white/icon_plus.png",
	"./ikony/yellow/icon-add.png": "./assets/images/ikony/yellow/icon-add.png",
	"./ikony/yellow/icon-address.png": "./assets/images/ikony/yellow/icon-address.png",
	"./ikony/yellow/icon-arrow-left.png": "./assets/images/ikony/yellow/icon-arrow-left.png",
	"./ikony/yellow/icon-arrow-right.png": "./assets/images/ikony/yellow/icon-arrow-right.png",
	"./ikony/yellow/icon-calendar.png": "./assets/images/ikony/yellow/icon-calendar.png",
	"./ikony/yellow/icon-cart-yellow.png": "./assets/images/ikony/yellow/icon-cart-yellow.png",
	"./ikony/yellow/icon-cart.png": "./assets/images/ikony/yellow/icon-cart.png",
	"./ikony/yellow/icon-clock.png": "./assets/images/ikony/yellow/icon-clock.png",
	"./ikony/yellow/icon-codes.png": "./assets/images/ikony/yellow/icon-codes.png",
	"./ikony/yellow/icon-delivery.png": "./assets/images/ikony/yellow/icon-delivery.png",
	"./ikony/yellow/icon-disability.png": "./assets/images/ikony/yellow/icon-disability.png",
	"./ikony/yellow/icon-drag-left.png": "./assets/images/ikony/yellow/icon-drag-left.png",
	"./ikony/yellow/icon-drag-right.png": "./assets/images/ikony/yellow/icon-drag-right.png",
	"./ikony/yellow/icon-email.png": "./assets/images/ikony/yellow/icon-email.png",
	"./ikony/yellow/icon-foreign-languages.png": "./assets/images/ikony/yellow/icon-foreign-languages.png",
	"./ikony/yellow/icon-grid.svg": "./assets/images/ikony/yellow/icon-grid.svg",
	"./ikony/yellow/icon-history.png": "./assets/images/ikony/yellow/icon-history.png",
	"./ikony/yellow/icon-home.png": "./assets/images/ikony/yellow/icon-home.png",
	"./ikony/yellow/icon-info.png": "./assets/images/ikony/yellow/icon-info.png",
	"./ikony/yellow/icon-invoice.png": "./assets/images/ikony/yellow/icon-invoice.png",
	"./ikony/yellow/icon-listing.svg": "./assets/images/ikony/yellow/icon-listing.svg",
	"./ikony/yellow/icon-logo.png": "./assets/images/ikony/yellow/icon-logo.png",
	"./ikony/yellow/icon-loupe.png": "./assets/images/ikony/yellow/icon-loupe.png",
	"./ikony/yellow/icon-password.png": "./assets/images/ikony/yellow/icon-password.png",
	"./ikony/yellow/icon-plane.png": "./assets/images/ikony/yellow/icon-plane.png",
	"./ikony/yellow/icon-remove.png": "./assets/images/ikony/yellow/icon-remove.png",
	"./ikony/yellow/icon-settings-yellow.png": "./assets/images/ikony/yellow/icon-settings-yellow.png",
	"./ikony/yellow/icon-settings.png": "./assets/images/ikony/yellow/icon-settings.png",
	"./ikony/yellow/icon-shopping.png": "./assets/images/ikony/yellow/icon-shopping.png",
	"./ikony/yellow/icon-special-needs.png": "./assets/images/ikony/yellow/icon-special-needs.png",
	"./ikony/yellow/icon-thumb.png": "./assets/images/ikony/yellow/icon-thumb.png",
	"./ikony/yellow/icon-tickets.png": "./assets/images/ikony/yellow/icon-tickets.png",
	"./ikony/yellow/icon-time-of-sightseeing.png": "./assets/images/ikony/yellow/icon-time-of-sightseeing.png",
	"./ikony/yellow/icon-user-2.png": "./assets/images/ikony/yellow/icon-user-2.png",
	"./ikony/yellow/icon-user.png": "./assets/images/ikony/yellow/icon-user.png",
	"./ikony/yellow/icon__tour-02.png": "./assets/images/ikony/yellow/icon__tour-02.png",
	"./ikony/yellow/icon__tour-03.png": "./assets/images/ikony/yellow/icon__tour-03.png",
	"./ikony/yellow/icon__tour-04.png": "./assets/images/ikony/yellow/icon__tour-04.png",
	"./ikony/yellow/icon__tour.png": "./assets/images/ikony/yellow/icon__tour.png",
	"./ikony/yellow/icon_plus.png": "./assets/images/ikony/yellow/icon_plus.png",
	"./img-spektakl-02.jpg": "./assets/images/img-spektakl-02.jpg",
	"./img-spektakl.jpg": "./assets/images/img-spektakl.jpg",
	"./jezioro_labedzie.jpg": "./assets/images/jezioro_labedzie.jpg",
	"./jpg.png": "./assets/images/jpg.png",
	"./karty-przedplacone.jpg": "./assets/images/karty-przedplacone.jpg",
	"./kosz.png": "./assets/images/kosz.png",
	"./lazy-loading-preloader.gif": "./assets/images/lazy-loading-preloader.gif",
	"./logo-frogriot.svg": "./assets/images/logo-frogriot.svg",
	"./logo/logo_black_256@2x.png": "./assets/images/logo/logo_black_256@2x.png",
	"./logo/logo_white_256@2x.png": "./assets/images/logo/logo_white_256@2x.png",
	"./logo/logo_yellow_256@2x.png": "./assets/images/logo/logo_yellow_256@2x.png",
	"./madame_miniatura_do_lkalendarium.jpg": "./assets/images/madame_miniatura_do_lkalendarium.jpg",
	"./main.jpg": "./assets/images/main.jpg",
	"./miodownik.jpg": "./assets/images/miodownik.jpg",
	"./mlynarskiego.png": "./assets/images/mlynarskiego.png",
	"./mobile.svg": "./assets/images/mobile.svg",
	"./moniuszki_parter_mobile.jpg": "./assets/images/moniuszki_parter_mobile.jpg",
	"./moniuszko200_logotyp_330px225.png": "./assets/images/moniuszko200_logotyp_330px225.png",
	"./more_info.jpg": "./assets/images/more_info.jpg",
	"./mov.png": "./assets/images/mov.png",
	"./mp3.png": "./assets/images/mp3.png",
	"./napoj_milosny-02.jpg": "./assets/images/napoj_milosny-02.jpg",
	"./napoj_milosny.jpg": "./assets/images/napoj_milosny.jpg",
	"./nasze_publikacje.jpg": "./assets/images/nasze_publikacje.jpg",
	"./niepelnosprawny.jpg": "./assets/images/niepelnosprawny.jpg",
	"./noimage.png": "./assets/images/noimage.png",
	"./odt.png": "./assets/images/odt.png",
	"./openhand.png": "./assets/images/openhand.png",
	"./opera_w_kadrze_mini_.jpg": "./assets/images/opera_w_kadrze_mini_.jpg",
	"./pamiatka-1.png": "./assets/images/pamiatka-1.png",
	"./pamiatka-2.png": "./assets/images/pamiatka-2.png",
	"./pamiatka-3.png": "./assets/images/pamiatka-3.png",
	"./parter.png": "./assets/images/parter.png",
	"./pdf.png": "./assets/images/pdf.png",
	"./petla.png": "./assets/images/petla.png",
	"./plan_mapy_redutowe_sektora.png": "./assets/images/plan_mapy_redutowe_sektora.png",
	"./plan_sali_moniuszki.jpg": "./assets/images/plan_sali_moniuszki.jpg",
	"./platnosci.jpg": "./assets/images/platnosci.jpg",
	"./png.png": "./assets/images/png.png",
	"./poranek_muzyczny_mini.jpg": "./assets/images/poranek_muzyczny_mini.jpg",
	"./prezent.png": "./assets/images/prezent.png",
	"./product_search-02.jpg": "./assets/images/product_search-02.jpg",
	"./product_search-03.jpg": "./assets/images/product_search-03.jpg",
	"./product_search-04.jpg": "./assets/images/product_search-04.jpg",
	"./product_search.jpg": "./assets/images/product_search.jpg",
	"./produkt-02.jpg": "./assets/images/produkt-02.jpg",
	"./produkt-03.jpg": "./assets/images/produkt-03.jpg",
	"./produkt-04.jpg": "./assets/images/produkt-04.jpg",
	"./produkt-1.jpg": "./assets/images/produkt-1.jpg",
	"./produkt-2.jpg": "./assets/images/produkt-2.jpg",
	"./produkt-3.jpg": "./assets/images/produkt-3.jpg",
	"./produkt.jpg": "./assets/images/produkt.jpg",
	"./produkt__main.jpg": "./assets/images/produkt__main.jpg",
	"./radio_chopin_plakat_cut_370x370.jpg": "./assets/images/radio_chopin_plakat_cut_370x370.jpg",
	"./rar.png": "./assets/images/rar.png",
	"./related-06.jpg": "./assets/images/related-06.jpg",
	"./related-07.jpg": "./assets/images/related-07.jpg",
	"./related.jpg": "./assets/images/related.jpg",
	"./sala-02.jpg": "./assets/images/sala-02.jpg",
	"./sala-03.jpg": "./assets/images/sala-03.jpg",
	"./sala-04.jpg": "./assets/images/sala-04.jpg",
	"./sala-05.jpg": "./assets/images/sala-05.jpg",
	"./sala-06.jpg": "./assets/images/sala-06.jpg",
	"./sala-07.jpg": "./assets/images/sala-07.jpg",
	"./sala-08.jpg": "./assets/images/sala-08.jpg",
	"./sala-09.jpg": "./assets/images/sala-09.jpg",
	"./sala-akt.jpg": "./assets/images/sala-akt.jpg",
	"./sala-mobile.png": "./assets/images/sala-mobile.png",
	"./sala.jpg": "./assets/images/sala.jpg",
	"./sala_bilety_numerowane_mobile_03.jpg": "./assets/images/sala_bilety_numerowane_mobile_03.jpg",
	"./sala_mapy_redutowe.png": "./assets/images/sala_mapy_redutowe.png",
	"./sala_mlynarskiego.png": "./assets/images/sala_mlynarskiego.png",
	"./sala_niepelno.png": "./assets/images/sala_niepelno.png",
	"./sala_parter.jpg": "./assets/images/sala_parter.jpg",
	"./sala_parter_amfiteatr.jpg": "./assets/images/sala_parter_amfiteatr.jpg",
	"./sala_petla.png": "./assets/images/sala_petla.png",
	"./sala_redutowe.png": "./assets/images/sala_redutowe.png",
	"./scena_parter.jpg": "./assets/images/scena_parter.jpg",
	"./seat-hover.jpg": "./assets/images/seat-hover.jpg",
	"./social-fb.png": "./assets/images/social-fb.png",
	"./social-instagram_2016-white.png": "./assets/images/social-instagram_2016-white.png",
	"./social-media/desktop/BIP.png": "./assets/images/social-media/desktop/BIP.png",
	"./social-media/desktop/FB.png": "./assets/images/social-media/desktop/FB.png",
	"./social-media/desktop/Logo_Instagrama_Fiolet_.png": "./assets/images/social-media/desktop/Logo_Instagrama_Fiolet_.png",
	"./social-media/desktop/YT.png": "./assets/images/social-media/desktop/YT.png",
	"./social-media/desktop/twitterwww60.png": "./assets/images/social-media/desktop/twitterwww60.png",
	"./social-media/desktop/x-blue.png": "./assets/images/social-media/desktop/x-blue.png",
	"./social-media/mobile/social-fb.png": "./assets/images/social-media/mobile/social-fb.png",
	"./social-media/mobile/social-instagram_2016-white.png": "./assets/images/social-media/mobile/social-instagram_2016-white.png",
	"./social-media/mobile/social-twitter.png": "./assets/images/social-media/mobile/social-twitter.png",
	"./social-media/mobile/social-yt.png": "./assets/images/social-media/mobile/social-yt.png",
	"./social-media/mobile/x-mobile.png": "./assets/images/social-media/mobile/x-mobile.png",
	"./social-yt.png": "./assets/images/social-yt.png",
	"./sold-out-overlay.png": "./assets/images/sold-out-overlay.png",
	"./special_edition_mobile.jpg": "./assets/images/special_edition_mobile.jpg",
	"./spektakl_thumb-02.jpg": "./assets/images/spektakl_thumb-02.jpg",
	"./spektakl_thumb-03.jpg": "./assets/images/spektakl_thumb-03.jpg",
	"./spektakl_thumb-04.jpg": "./assets/images/spektakl_thumb-04.jpg",
	"./spektakl_thumb.jpg": "./assets/images/spektakl_thumb.jpg",
	"./spinner-white.svg": "./assets/images/spinner-white.svg",
	"./spinner.svg": "./assets/images/spinner.svg",
	"./sprite-black-on-white-1.png": "./assets/images/sprite-black-on-white-1.png",
	"./sprite-black-on-white-2.png": "./assets/images/sprite-black-on-white-2.png",
	"./sprite-black-on-white-3.png": "./assets/images/sprite-black-on-white-3.png",
	"./sprite-black-on-yellow-1.png": "./assets/images/sprite-black-on-yellow-1.png",
	"./sprite-black-on-yellow-2.png": "./assets/images/sprite-black-on-yellow-2.png",
	"./sprite-black-on-yellow-3.png": "./assets/images/sprite-black-on-yellow-3.png",
	"./sprite-default-1.png": "./assets/images/sprite-default-1.png",
	"./sprite-default-2.png": "./assets/images/sprite-default-2.png",
	"./sprite-default-3.png": "./assets/images/sprite-default-3.png",
	"./sprite-white-on-black-1.png": "./assets/images/sprite-white-on-black-1.png",
	"./sprite-white-on-black-2.png": "./assets/images/sprite-white-on-black-2.png",
	"./sprite-white-on-black-3.png": "./assets/images/sprite-white-on-black-3.png",
	"./sprite-yellow-on-black-1.png": "./assets/images/sprite-yellow-on-black-1.png",
	"./sprite-yellow-on-black-2.png": "./assets/images/sprite-yellow-on-black-2.png",
	"./sprite-yellow-on-black-3.png": "./assets/images/sprite-yellow-on-black-3.png",
	"./sprite.png": "./assets/images/sprite.png",
	"./thumb-02.jpg": "./assets/images/thumb-02.jpg",
	"./thumb-03.jpg": "./assets/images/thumb-03.jpg",
	"./thumb-04.jpg": "./assets/images/thumb-04.jpg",
	"./thumb-05.jpg": "./assets/images/thumb-05.jpg",
	"./thumb.jpg": "./assets/images/thumb.jpg",
	"./tick.jpg": "./assets/images/tick.jpg",
	"./tick.svg": "./assets/images/tick.svg",
	"./tours-02.jpg": "./assets/images/tours-02.jpg",
	"./tours-03.jpg": "./assets/images/tours-03.jpg",
	"./tours.jpg": "./assets/images/tours.jpg",
	"./trash.png": "./assets/images/trash.png",
	"./twon-404-bg.jpg": "./assets/images/twon-404-bg.jpg",
	"./txt.png": "./assets/images/txt.png",
	"./ue.gif": "./assets/images/ue.gif",
	"./ue.png": "./assets/images/ue.png",
	"./wycieczka.png": "./assets/images/wycieczka.png",
	"./xls.png": "./assets/images/xls.png",
	"./xlsx.png": "./assets/images/xlsx.png",
	"./zakupy.jpg": "./assets/images/zakupy.jpg",
	"./zegar.jpg": "./assets/images/zegar.jpg",
	"./zip.png": "./assets/images/zip.png",
	"./zwiedzanie_02.jpg": "./assets/images/zwiedzanie_02.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/images sync recursive ^((?%21miejsca).)*\\.(gif%7Cpng%7Cjpe?g%7Csvg)$/";